<template>
  <label
    class="tw:flex! tw:relative tw:flex-1 tw:min-w-0 tw:cursor-pointer tw:select-none tw:flex-col tw:items-start tw:gap-1.5 tw:rounded-md tw:border-2 tw:border-solid tw:bg-white tw:p-4 tw:pr-11 tw:text-left tw:transition-[border-color,box-shadow] tw:duration-150 tw:ease-in-out tw:hover:tw:border-primary tw:focus-within:tw:shadow-[0_0_0_4px_rgb(0_122_255/0.1)]"
    :class="checked ? 'tw:border-primary tw:shadow-raised' : 'tw:border-gray-200'">
    <!-- the native input stays off-screen but carries state and keyboard navigation -->
    <input v-model="model" type="radio" :value="value" class="tw:sr-only" v-bind="$attrs" />

    <span
      v-if="checked"
      class="tw:absolute tw:top-4 tw:right-4 tw:flex tw:size-[22px] tw:items-center tw:justify-center tw:rounded-full tw:bg-primary tw:text-white"
      aria-hidden="true">
      <IconCheck :size="14" stroke-width="2.5" />
    </span>

    <component
      :is="icon"
      v-if="icon"
      :size="24"
      class="tw:mb-1"
      :class="checked ? 'tw:text-primary' : 'tw:text-gray-900'" />

    <span class="tw:text-14 tw:font-semibold tw:text-gray-900">{{ title }}</span>

    <span v-if="description || $slots.default" class="tw:text-13 tw:font-normal tw:text-muted">
      <slot>{{ description }}</slot>
    </span>
  </label>
</template>

<script setup lang="ts">
/** instances share a group via the same v-model; pass a common `name` for keyboard navigation */
import { computed, type Component } from 'vue';
import { IconCheck } from '@tabler/icons-vue';

defineOptions({ inheritAttrs: false });

interface Props {
  value: string;
  title: string;
  description?: string;
  icon?: Component;
}

const props = defineProps<Props>();
const model = defineModel<string>({ required: true });

const checked = computed(() => model.value === props.value);
</script>
